import { hierarchyNodeActions, service } from '..';

const endpoint = 'hierarchyNode';

export const hierarchyNodeService = {
  get: () => service( endpoint ).get().then( result => ( { type: hierarchyNodeActions.LOAD, node: result.data } ) )
};